import { Button, Input, Modal } from '@platform/components';
import { useLocation } from 'wouter';
import { ROUTES } from '../routes/consts';
import cx from 'classix';
import { SentIntroDetails } from '@platform/client/schemas';

/** A modal for viewing a sent introduction. Very similar to the 'Sent introduction'
 * modal from My Projects, but not coupled to My Projects data models. */
const ViewIntroductionModal = ({
  // introId,
  isOpen,
  setIsOpen,
  otherPartyType,
  details,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  otherPartyType: 'professional' | 'organization';
  details: SentIntroDetails;
}) => {
  const [_, navigate] = useLocation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      title='Sent introduction'
      headerDivision='divider'
      variant='dialog'
      primaryCTA={{
        text: 'See in My Projects',
        callback: () => {
          navigate(`~/platform/dashboard${ROUTES.MY_PROJECTS}?introductionId=${details.introId}`);
        },
      }}
      secondaryCTA={{
        text: 'Close',
        callback: () => setIsOpen(false),
      }}
      ignoreExtraPadding
    >
      <div className='flex flex-col items-center text-center gap-6'>
        <div className='w-full grid grid-cols-2 gap-4 text-left'>
          <div>
            <div className='text-base font-medium'>
              {otherPartyType === 'professional' ? 'Professional' : 'Organization'}
            </div>
            <Button
              variant='link-color'
              size='md'
              additionalClassnames='text-left justify-start h-fit'
              href={
                otherPartyType === 'professional' ?
                  `/platform/directory/professionals/${details.proId}`
                : `/platform/directory/organizations/${details.orgId}`
              }
            >
              {details.orgName}
            </Button>
          </div>
          <div>
            <div className='text-base font-medium'>Timezone</div>
            <span className='font-semibold text-sm'>{details.timezone}</span>
          </div>
          <div>
            <div className='text-base font-medium'>Project</div>
            {details.projectId && details.projectId > -1 && (
              <Button
                variant='link-color'
                size='sm'
                additionalClassnames='text-left justify-start h-fit'
                href={`/platform/directory/projects/${details.projectId}`}
              >
                {details.projectName}
              </Button>
            )}
          </div>
          <div>
            <div className='text-base font-medium'>Role</div>
            <span className='font-semibold text-sm'>
              {details.role[0].toUpperCase() + details.role.substring(1)}
            </span>
          </div>
        </div>
        <div className={cx('w-full', details.message.length > 300 ? 'h-96' : 'h-48')}>
          <Input
            stretchHeight
            type='multiline'
            value={details.message}
            placeholder=''
            disabled
            onChange={(_e) => {}}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ViewIntroductionModal;
